import {
  LedgerAccountTypeEnum,
  LedgerNormalBalanceEnum,
  LedgerSubcategoryOption,
} from '../../../cfo/models/ledger.models';

export const MOCK_SUBCATEGORY_OPTIONS: LedgerSubcategoryOption[] = [
  {
    value: 'asset.accumulated_depreciation',
    label: 'Accumulated Depreciation',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'asset.cash',
    label: 'Cash',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'asset.contracts',
    label: 'Contracts',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'asset.fixed_assets',
    label: 'Fixed Assets',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'asset.other_assets',
    label: 'Other Assets',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'asset.other_current_assets',
    label: 'Other Current Assets',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'asset.prepaids',
    label: 'Prepaids',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'asset.receivables',
    label: 'Receivables',
    financial_class: 'asset',
    financial_class_label: 'Asset',
    type: LedgerAccountTypeEnum.ASSET,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'liability.accruals',
    label: 'Accruals',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.contracts',
    label: 'Contracts',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.insurance',
    label: 'Insurance',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.long_term_debt',
    label: 'Long-Term Debt',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.other_current_liabilities',
    label: 'Other Current Liabilities',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.payables',
    label: 'Payables',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.payroll_liabilities',
    label: 'Payroll Liabilities',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.payroll_taxes_payable',
    label: 'Payroll Taxes Payable',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.short_term_debt',
    label: 'Short-Term Debt',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'liability.taxes',
    label: 'Taxes',
    financial_class: 'liability',
    financial_class_label: 'Liability',
    type: LedgerAccountTypeEnum.LIABILITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'equity.contributed_capital',
    label: 'Contributed Capital',
    financial_class: 'equity',
    financial_class_label: 'Equity',
    type: LedgerAccountTypeEnum.EQUITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'equity.distributions',
    label: 'Distributions',
    financial_class: 'equity',
    financial_class_label: 'Equity',
    type: LedgerAccountTypeEnum.EQUITY,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'equity.opening_balance_equity',
    label: 'Opening Balance Equity',
    financial_class: 'equity',
    financial_class_label: 'Equity',
    type: LedgerAccountTypeEnum.EQUITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: false,
  },
  {
    value: 'equity.retained_earnings',
    label: 'Retained Earnings',
    financial_class: 'equity',
    financial_class_label: 'Equity',
    type: LedgerAccountTypeEnum.EQUITY,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: false,
  },
  {
    value: 'revenue.change_orders',
    label: 'Change Orders',
    financial_class: 'revenue',
    financial_class_label: 'Revenue',
    type: LedgerAccountTypeEnum.REVENUE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'revenue.contract_revenue',
    label: 'Contract Revenue',
    financial_class: 'revenue',
    financial_class_label: 'Revenue',
    type: LedgerAccountTypeEnum.REVENUE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'revenue.service_revenue',
    label: 'Service Revenue',
    financial_class: 'revenue',
    financial_class_label: 'Revenue',
    type: LedgerAccountTypeEnum.REVENUE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'revenue.t_and_m_revenue',
    label: 'T&M Revenue',
    financial_class: 'revenue',
    financial_class_label: 'Revenue',
    type: LedgerAccountTypeEnum.REVENUE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'direct_cost.allocated_indirect',
    label: 'Allocated Indirect',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.allocated_overhead',
    label: 'Allocated Overhead',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.bonds',
    label: 'Bonds',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.equipment',
    label: 'Equipment',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.general_conditions',
    label: 'General Conditions',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.labor',
    label: 'Labor',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.labor_burden',
    label: 'Labor Burden',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.materials',
    label: 'Materials',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.other_direct',
    label: 'Other Direct',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.quality',
    label: 'Quality',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.subcontractors',
    label: 'Subcontractors',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.travel',
    label: 'Travel',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'direct_cost.warranty',
    label: 'Warranty',
    financial_class: 'direct_cost',
    financial_class_label: 'Direct Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'indirect_cost.allocated_indirect',
    label: 'Allocated Indirect',
    financial_class: 'indirect_cost',
    financial_class_label: 'Indirect Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'indirect_cost.depreciation',
    label: 'Depreciation',
    financial_class: 'indirect_cost',
    financial_class_label: 'Indirect Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'indirect_cost.fleet_and_equipment',
    label: 'Fleet and Equipment',
    financial_class: 'indirect_cost',
    financial_class_label: 'Indirect Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'indirect_cost.occupancy',
    label: 'Occupancy',
    financial_class: 'indirect_cost',
    financial_class_label: 'Indirect Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'indirect_cost.safety',
    label: 'Safety',
    financial_class: 'indirect_cost',
    financial_class_label: 'Indirect Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'indirect_cost.small_tools',
    label: 'Small Tools',
    financial_class: 'indirect_cost',
    financial_class_label: 'Indirect Cost',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.administrative',
    label: 'Administrative',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.bonds',
    label: 'Bonds',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.credit_losses',
    label: 'Credit Losses',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.depreciation',
    label: 'Depreciation',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.insurance',
    label: 'Insurance',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.occupancy',
    label: 'Occupancy',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.office',
    label: 'Office',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.other_expense',
    label: 'Other Expense',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.overhead_applied',
    label: 'Overhead Applied',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'expense.overhead_auto',
    label: 'Overhead Auto',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.payroll',
    label: 'Payroll',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.people',
    label: 'People',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.professional_fees',
    label: 'Professional Fees',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.sales_and_marketing',
    label: 'Sales and Marketing',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.taxes',
    label: 'Taxes',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'expense.travel_and_meals',
    label: 'Travel and Meals',
    financial_class: 'expense',
    financial_class_label: 'Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'other_income.asset_disposal',
    label: 'Asset Disposal',
    financial_class: 'other_income',
    financial_class_label: 'Other Income',
    type: LedgerAccountTypeEnum.REVENUE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'other_income.interest_income',
    label: 'Interest Income',
    financial_class: 'other_income',
    financial_class_label: 'Other Income',
    type: LedgerAccountTypeEnum.REVENUE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'other_income.other_income',
    label: 'Other Income',
    financial_class: 'other_income',
    financial_class_label: 'Other Income',
    type: LedgerAccountTypeEnum.REVENUE,
    normal_balance: LedgerNormalBalanceEnum.CREDIT,
    selectable: true,
  },
  {
    value: 'other_expense.income_tax',
    label: 'Income Tax',
    financial_class: 'other_expense',
    financial_class_label: 'Other Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'other_expense.interest_expense',
    label: 'Interest Expense',
    financial_class: 'other_expense',
    financial_class_label: 'Other Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
  {
    value: 'other_expense.other_expense',
    label: 'Other Expense',
    financial_class: 'other_expense',
    financial_class_label: 'Other Expense',
    type: LedgerAccountTypeEnum.EXPENSE,
    normal_balance: LedgerNormalBalanceEnum.DEBIT,
    selectable: true,
  },
];
